/**
 * Scopes are general concepts that may be used by the SockAPI or
 * backend interfaces. The scopes used by SockAPI are defined in
 * scope-state.ts as SockAPIScope.
 */
export enum ScopeType {
  /**
   * A dummy scope. Should not expose any functionality.
   * Used to ensure that all scope type unions are non-empty
   * (to preserve functionality not currently used) since
   * empty unions cause problems with typescript.
   */
  DUMMY = "dummy",

  HUNT_ADMIN = "hunt_admin",
  SERVER_HEALTH = "server_health",
  BIG_BOARD = "big_board",
  TEAM_LIST = "team_list",
  TEAM_MEMBERS = "team_members",
  TEAM = "team",
  TEAM_ANSWERABLE = "team_answerable",
  PUZZLE_CONTENT = "puzzle_content",
  ERRATUM_CONTENT = "erratum_content",
  TEAM_ERRATA = "team_errata",
  SOLUTION_CONTENT = "solution_content",
  CANNED_HINT = "canned_hint",
  HINT = "hint",
  TEAM_CANNED_HINTS = "team_canned_hints",
  TEAM_HINTS = "team_hints",
  KEYFRAME = "keyframe",
  TEAM_CUTSCENES = "team_cutscenes",
  MOCK_DIRECT_BACKEND = "mock_direct_backend",
  ADMIN_QUEUE = "admin_queue",
  ADMIN_QUEUE_TASK = "admin_queue_task",
  TEAM_COLLECTIBLES = "team_collectibles",
  TEAM_TITLES = "team_titles",
  STATE_DOWNLOAD = "state_download",
  ADMIN_STATS = "admin_stats",
  STATS = "stats",
  HUNT_STATS = "hunt_stats",
  PUBLIC_SUBMISSIONS = "public_submissions",
  ROUND = "round",

  TEAM_BLUE_THEATRE = "team_blue_theatre",
  TEAM_TIMED_UNLOCK = "team_timed_unlock",
}
